import React from 'react';
import QRCode from 'react-qr-code';

function QRPage() {
  return (
    <div>
      <QRCode value="http://192.168.1.3:3000" />
    </div>
  );
}

export default QRPage;
